<template>
  <div class="membership-form-container">
    <div class="signup-form">
      <div class="form-item-group" v-if="currentStep === 'password'">
        <div class="form-item-label">
          <label for="password">{{ $i18n.t('views-reset-pwd-password-subtit1') }}*</label>
        </div>
        <div class="form-item-component">
          <SafeInput
            :className="{
              'signup-form-item': true,
              'input-border-err': passwordInfoErr,
            }"
            :type="passwordInputType"
            id="password"
            :placeholder="$i18n.t('views-reset-pwd-password-subtit1')"
            autocomplete="new-password"
            role="input password"
            v-model.trim="formData.password"
            @input="
              e => {
                handleValueChange(e, 'password');
              }
            "
          />
          <img
            v-show="showPassword"
            class="eye"
            src="~img/icon-feather-eye-on.svg"
            @click="changePasswordInputStatus('password')"
            alt="hide password"
          />
          <img
            v-show="!showPassword"
            class="eye"
            src="~img/icon-feather-eye-off.svg"
            @click="changePasswordInputStatus('text')"
            alt="show password"
          />
        </div>
        <!-- check 错误提示 -->
        <p v-if="passwordInfoErr" class="error-message">{{ passwordErrMsg }}</p>
      </div>

      <div class="form-item-group" v-if="currentStep === 'password'">
        <div class="form-item-label">
          <label for="confirmPassword">{{ $i18n.t('views-reset-pwd-password-subtit2') }}*</label>
        </div>
        <div class="form-item-component">
          <SafeInput
            :className="{
              'signup-form-item': true,
              'input-border-err': confirmPasswordInfoErr,
            }"
            :type="confirmPasswordInputType"
            id="confirmPassword"
            :placeholder="$i18n.t('views-reset-pwd-password-subtit2')"
            autocomplete="new-password"
            role="input confirm password"
            v-model.trim="formData.confirmPassword"
            maxlength="19"
            @input="
              e => {
                handleValueChange(e, 'confirmPassword');
              }
            "
          />
          <img
            v-show="showConfirmPassword"
            class="eye"
            src="~img/icon-feather-eye-on.svg"
            @click="changeConfirmPasswordInputStatus('password')"
            alt="hide confirm password"
          />
          <img
            v-show="!showConfirmPassword"
            class="eye"
            src="~img/icon-feather-eye-off.svg"
            @click="changeConfirmPasswordInputStatus('text')"
            alt="show confirm password"
          />
        </div>
        <!-- check 错误提示 -->
        <p v-if="confirmPasswordInfoErr" class="error-message">{{ confirmPasswordErrMsg }}</p>
      </div>

      <div class="form-item-group" v-if="currentStep === 'email'">
        <div class="form-item-label">
          <label for="password">{{ $i18n.t('views-reset-pwd-email-subtit') }}*</label>
        </div>
        <div class="form-item-component">
          <SafeInput
            :className="{
              'signup-form-item': true,
              'input-border-err': usernameInfoErr,
            }"
            :type="usernameInputType"
            id="username"
            :placeholder="$i18n.t('views-reset-pwd-email-subtit')"
            autocomplete="new-password"
            role="input username"
            v-model.trim="formData.username"
            @input="
              e => {
                handleValueChange(e, 'username');
              }
            "
          />
          <img
            v-show="showUsername"
            class="eye"
            src="~img/icon-feather-eye-on.svg"
            @click="changeUsernameInputStatus('password')"
            alt="hide username"
          />
          <img
            v-show="!showUsername"
            class="eye"
            src="~img/icon-feather-eye-off.svg"
            @click="changeUsernameInputStatus('text')"
            alt="show username"
          />
        </div>
        <!-- check 错误提示 -->
        <p v-if="usernameInfoErr" class="error-message">{{ usernameErrMsg }}</p>
      </div>

      <div class="form-item-group" v-if="currentStep === 'verification'">
        <div class="form-item-label">
          <label for="verificationCode">{{ $i18n.t('views-reset-pwd-verif-subtit') }}*</label>
        </div>
        <div class="form-item-component">
          <SafeInput
            :className="{
              'signup-form-item': true,
              'input-border-err': verificationCodeInfoErr,
            }"
            :type="verificationCodeInputType"
            id="verificationCode"
            :placeholder="$i18n.t('views-reset-pwd-verif-subtit')"
            autocomplete="new-password"
            role="input verification code"
            v-model.trim="formData.verificationCode"
            @input="
              e => {
                handleValueChange(e, 'verificationCode');
              }
            "
          />
          <img
            v-show="showVerificationCode"
            class="eye"
            src="~img/icon-feather-eye-on.svg"
            @click="changeVerificationCodeInputStatus('password')"
            alt="hide verification code"
          />
          <img
            v-show="!showVerificationCode"
            class="eye"
            src="~img/icon-feather-eye-off.svg"
            @click="changeVerificationCodeInputStatus('text')"
            alt="show verification code"
          />
        </div>
        <!-- check 错误提示 -->
        <p v-if="verificationCodeInfoErr" class="error-message">{{ verificationCodeErrMsg }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import SafeInput from '@/components/SafeInput/index.vue';

  export default {
    name: 'ResetPasswordForm',
    components: {
      SafeInput,
    },
    props: {
      currentStep: {
        type: String,
        default: 'password',
      },
      errMessage: {
        type: Array,
        default: () => [],
      },
    },
    watch: {
      errMessage: {
        handler(newVal) {
          if (newVal.length) {
            newVal.forEach(item => {
              switch (item.name) {
                case 'password':
                  this.passwordInfoErr = true;
                  this.passwordErrMsg = item.errMessage;
                  break;
                case 'confirmPassword':
                  this.confirmPasswordInfoErr = true;
                  this.confirmPasswordErrMsg = item.errMessage;
                  break;
                case 'username':
                  this.usernameInfoErr = true;
                  this.usernameErrMsg = item.errMessage;
                  break;
                case 'verificationCode':
                  this.verificationCodeInfoErr = true;
                  this.verificationCodeErrMsg = item.errMessage;
                  break;
                default:
                  break;
              }
            });
          }
        },
        deep: true,
      },
    },
    data() {
      return {
        // 密码输入框
        passwordInputType: 'password',
        passwordInfoErr: false,
        passwordErrMsg: '',
        // 确认密码输入框
        confirmPasswordInputType: 'password',
        confirmPasswordInfoErr: false,
        confirmPasswordErrMsg: '',
        // 用户名输入框
        usernameInputType: 'text',
        usernameInfoErr: false,
        usernameErrMsg: '',
        // 验证码输入框
        verificationCodeInputType: 'text',
        verificationCodeInfoErr: false,
        verificationCodeErrMsg: '',
        formData: {
          password: '',
          confirmPassword: '',
          username: '',
          verificationCode: '',
        },
      };
    },
    computed: {
      showPassword() {
        return this.passwordInputType === 'text';
      },
      showConfirmPassword() {
        return this.confirmPasswordInputType === 'text';
      },
      showUsername() {
        return this.usernameInputType === 'text';
      },
      showVerificationCode() {
        return this.verificationCodeInputType === 'text';
      },
      // 给父组件用, 父组件不需改动代码
      modalValue() {
        const { password, confirmPassword, username, verificationCode } = this.formData;
        return {
          password,
          confirmPassword,
          username,
          verificationCode,
        };
      },
    },
    methods: {
      changePasswordInputStatus(value) {
        this.passwordInputType = value;
      },
      changeConfirmPasswordInputStatus(value) {
        this.confirmPasswordInputType = value;
      },
      changeUsernameInputStatus(value) {
        this.usernameInputType = value;
      },
      changeVerificationCodeInputStatus(value) {
        this.verificationCodeInputType = value;
      },
      handleValueChange(e, key) {
        switch (key) {
          case 'password':
            this.passwordInfoErr = false;
            this.passwordErrMsg = '';
            break;
          case 'confirmPassword':
            this.confirmPasswordInfoErr = false;
            this.confirmPasswordErrMsg = '';
            break;
          case 'username':
            this.usernameInfoErr = false;
            this.usernameErrMsg = '';
            break;
          case 'verificationCode':
            this.verificationCodeInfoErr = false;
            this.verificationCodeErrMsg = '';
            break;
          default:
            break;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  @use './index';
  @use './mobile.scss';
</style>
